export const rolesHelper = {
    hasRole,
    hasAnyRole
}

export function hasRole (role) {

    var userHasRole = false
    const user = localStorage.getItem('user')

    if ((user !== undefined) && (user !== null) && (user !== 'undefined')) {

        const userRoles = JSON.parse(localStorage.getItem('user')).roles

        if (!Array.isArray(userRoles)) {
            userHasRole = role === userRoles
        } else {
            userHasRole = userRoles.includes(role)
        }
    }
    return userHasRole
}

export function hasAnyRole (roles) {
    var userHasRole = false

    for (var r of roles) {
        userHasRole = userHasRole || hasRole(r)
    }

    return userHasRole
}
